export default "__VITE_ASSET__BQ0DiFLV__"